import styled from "../../../../__compat__/styled-components/main.entry.mjs.mjs";
import { injectTypography } from "../../../../utils/injectTypography.mjs.mjs";
import { injectSpacing } from "../../../../api/spacing/injectSpacing.mjs.mjs";
import { injectHideScrollBar } from "../../../../utils/injectHideScrollBar.mjs.mjs";
import { injectOSXFontSmoothing } from "../../../../utils/injectOSXFontSmoothing.mjs.mjs";
export const optionCount = 4;
export const optionSize = 60;
export const optionOffset = optionSize * ((optionCount - 1) / 2);
export const StyledBarrelSelect = styled.ul.withConfig({ displayName: "auir-611444a-StyledBarrelSelect", componentId: "auir-611444a-10muylg" }) `
  --option-count: ${optionCount};
  --option-size: ${optionSize}px;
  --option-offset: calc(var(--option-size) * ((var(--option-count) - 1) / 2));

  position: relative;
  z-index: 1;

  display: flex;
  flex-flow: column nowrap;
  box-sizing: border-box;

  height: calc(var(--option-size) * var(--option-count));
  margin: 0;
  padding: 0;
  overflow: auto;
  overscroll-behavior: contain;

  line-height: var(--option-size);

  list-style: none;
  scroll-snap-type: y mandatory;

  ${injectHideScrollBar}

  /* This fixes an incompability between Firefox and the other browsers when
   * using padding inside an overflow container:
   * https://github.com/w3c/csswg-drafts/issues/129
   * https://bugzilla.mozilla.org/show_bug.cgi?id=748518
   */
  &::before,
  &::after {
    display: block;
    flex-shrink: 0;
    height: var(--option-offset);

    content: '';
  }
`;
export const StyledOption = styled.li.withConfig({ displayName: "auir-611444a-StyledOption", componentId: "auir-611444a-ohkmpg" }) `
  ${(props) => injectTypography(props, 'copy1')}
  ${injectOSXFontSmoothing(true)}

  box-sizing: border-box;
  scroll-snap-align: center;

  min-width: var(--option-size);
  min-height: var(--option-size);
  padding-inline-start: var(${(props) => props.theme.responsive.spacing.s});
  padding-inline-end: var(${(props) => props.theme.responsive.spacing.s});

  color: var(${(props) => props.theme.colors.interaction.secondary.default});
  line-height: var(--option-size);

  cursor: pointer;

  &[aria-selected='true'] {
    color: var(${(props) => props.theme.colors.interaction.secondary.active});

    cursor: auto;
  }
`;
export const StyledBarrelSelectGroup = styled.div.withConfig({ displayName: "auir-611444a-StyledBarrelSelectGroup", componentId: "auir-611444a-qvylol" }) `
  --option-size: ${optionSize}px;

  position: relative;

  display: grid;
  grid-auto-flow: column;
  grid-template-rows: auto;
  justify-content: center;

  column-gap: var(${(props) => props.theme.responsive.spacing.s});

  &::before {
    position: absolute;
    top: calc(50% - var(--option-size) / 2);
    right: 0;
    left: 0;
    z-index: 0;

    display: block;
    width: 100%;
    height: var(--option-size);

    background-color: var(
      ${(props) => props.theme.colors.ui.highlight.tertiary}
    );

    content: '';
  }

  ${injectSpacing('margin')}
`;
//# sourceMappingURL=BarrelSelect.styles.mjs.mjs.map